// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Brand */
  --primary: #2563eb;
  --primary-light: #dbeafe;
  --primary-glow: rgba(37, 99, 235, 0.25);
  --secondary: #fbbf24;
  --accent: #2563eb;
  --purple: #8b5cf6;
  --success: #10b981;
  --warning: #f59e0b;
  --danger: #ef4444;

  /* Surfaces */
  --bg-main: #f8fafc;
  --bg-card: #ffffff;
  --bg-surface: #f1f5f9;
  --bg-input: #ffffff;
  --white: #ffffff;
  --light: #f1f5f9;
  --dark: #1e293b;
  --gray: #64748b;

  /* Text */
  --text-primary: #1e293b;
  --text-secondary: #64748b;

  /* Borders & Glass */
  --border: #e2e8f0;
  --glass: rgba(255, 255, 255, 0.8);
  --glass-border: rgba(226, 232, 240, 0.8);

  /* Shadows */
  --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  --shadow-sm: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --shadow-md: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --shadow-lg: 0 25px 50px -12px rgb(0 0 0 / 0.25);
}

/* ══════════════════════════════════════════════════════
   DARK THEME — Visual completo com profundidade real
══════════════════════════════════════════════════════ */
[data-theme='dark'] {
  /* Brand adjustments */
  --primary: #3b82f6;
  --primary-light: rgba(59, 130, 246, 0.18);
  --primary-glow: rgba(59, 130, 246, 0.35);
  --purple: #a78bfa;
  --success: #34d399;
  --warning: #fbbf24;
  --danger: #f87171;

  /* Surfaces — 3 níveis de elevação */
  --bg-main: #080e1a;         /* fundo base — quase preto */
  --bg-card: #111827;         /* cards / sidebar */
  --bg-surface: #1c2a3f;      /* linhas hover, table header, inputs */
  --bg-input: #0f172a;        /* fundo de inputs */
  --white: #111827;           /* onde o código usa var(--white) */
  --light: #1c2a3f;           /* onde o código usa var(--light) */
  --dark: #e2e8f0;            /* onde o código usa var(--dark) p/ texto */
  --gray: #94a3b8;

  /* Text */
  --text-primary: #e2e8f0;
  --text-secondary: #7c8fa8;

  /* Borders */
  --border: #1f3151;
  --glass: rgba(17, 24, 39, 0.92);
  --glass-border: rgba(59, 130, 246, 0.12);

  /* Shadows — mais intensas no escuro */
  --shadow-sm: 0 1px 3px 0 rgb(0 0 0 / 0.6);
  --shadow: 0 8px 20px -4px rgb(0 0 0 / 0.55), 0 2px 6px -2px rgb(0 0 0 / 0.4);
  --shadow-md: 0 20px 40px -8px rgb(0 0 0 / 0.65), 0 6px 12px -4px rgb(0 0 0 / 0.5);
  --shadow-lg: 0 40px 80px -16px rgb(0 0 0 / 0.8);
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'Outfit', sans-serif;
}

body {
  background: var(--bg-main);
  color: var(--text-primary);
  min-height: 100vh;
  overflow-x: hidden;
  -webkit-font-smoothing: antialiased;
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 6px;
}
::-webkit-scrollbar-track {
  background: transparent;
}
::-webkit-scrollbar-thumb {
  background: var(--border);
  border-radius: 10px;
}
::-webkit-scrollbar-thumb:hover {
  background: var(--text-secondary);
}

/* Dark theme — sidebar e cards com borda sutil azulada */
[data-theme='dark'] .sidebar {
  background: linear-gradient(180deg, #111827 0%, #0d1829 100%);
  border-right-color: #1f3151;
  box-shadow: 4px 0 24px rgb(0 0 0 / 0.4);
}

[data-theme='dark'] .nav-item:hover {
  background: rgba(59, 130, 246, 0.08);
  color: #60a5fa;
}

[data-theme='dark'] .nav-item.active {
  background: rgba(59, 130, 246, 0.15);
  border-color: rgba(59, 130, 246, 0.25);
  color: #60a5fa;
  box-shadow: inset 3px 0 0 #3b82f6;
}

[data-theme='dark'] .stat-card {
  background: linear-gradient(145deg, #111827, #0f1e35);
  border-color: #1f3151;
}

[data-theme='dark'] .stat-card:hover {
  border-color: rgba(59, 130, 246, 0.3);
  box-shadow: 0 0 0 1px rgba(59, 130, 246, 0.1), var(--shadow);
}

[data-theme='dark'] .chart-container {
  background: linear-gradient(145deg, #111827, #0f1e35);
  border-color: #1f3151;
}

[data-theme='dark'] .table-wrapper {
  background: #111827;
  border-color: #1f3151;
}

[data-theme='dark'] th {
  background: #0d1829;
  color: #60a5fa;
  border-bottom-color: #1f3151;
}

[data-theme='dark'] tr:hover td {
  background: rgba(59, 130, 246, 0.04);
}

[data-theme='dark'] td {
  border-bottom-color: #1a2744;
}

[data-theme='dark'] .detail-panel {
  background: linear-gradient(180deg, #111827 0%, #0d1829 100%);
  box-shadow: -12px 0 40px rgb(0 0 0 / 0.55);
  border-left: 1px solid #1f3151;
}

[data-theme='dark'] .detail-header {
  border-bottom-color: #1f3151;
  background: rgba(13, 24, 41, 0.8);
}

[data-theme='dark'] .modal {
  background: linear-gradient(145deg, #111827, #0f1e35);
  border: 1px solid #1f3151;
  box-shadow: 0 40px 80px -12px rgb(0 0 0 / 0.8), 0 0 0 1px rgba(59,130,246,0.06);
}

[data-theme='dark'] .modal-header {
  border-bottom-color: #1f3151;
  background: rgba(13, 24, 41, 0.5);
}

[data-theme='dark'] .modal-container {
  background: linear-gradient(145deg, #111827, #0f1e35);
  border-color: #1f3151;
  box-shadow: 0 40px 80px -12px rgb(0 0 0 / 0.8);
}

[data-theme='dark'] .glass-form {
  background: linear-gradient(145deg, #111827, #0f1e35);
  border-color: #1f3151;
}

[data-theme='dark'] .glass-input,
[data-theme='dark'] .input-field,
[data-theme='dark'] .login-input,
[data-theme='dark'] .form-group input,
[data-theme='dark'] .form-group select {
  background: #0a1626;
  border-color: #1f3151;
  color: var(--text-primary);
}

[data-theme='dark'] .glass-input:focus,
[data-theme='dark'] .input-field:focus,
[data-theme='dark'] .login-input:focus,
[data-theme='dark'] .form-group input:focus,
[data-theme='dark'] .form-group select:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
}

[data-theme='dark'] .form-group select option {
  background: #111827;
  color: var(--text-primary);
}

[data-theme='dark'] .btn-secondary {
  background: #1c2a3f;
  border-color: #1f3151;
  color: var(--text-secondary);
}

[data-theme='dark'] .btn-secondary:hover {
  background: #243352;
  color: var(--text-primary);
  border-color: rgba(59,130,246,0.3);
}

[data-theme='dark'] .btn-primary {
  box-shadow: 0 4px 15px rgba(59, 130, 246, 0.35);
}

[data-theme='dark'] .btn-primary:hover {
  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.5);
}

[data-theme='dark'] .toast {
  background: linear-gradient(145deg, #111827, #0d1829);
  border-color: #1f3151;
  box-shadow: var(--shadow-md);
}

[data-theme='dark'] .client-card {
  background: linear-gradient(145deg, #111827, #0f1e35);
  border-color: #1f3151;
}

[data-theme='dark'] .client-card:hover {
  border-color: rgba(59, 130, 246, 0.3);
  box-shadow: 0 0 0 1px rgba(59,130,246,0.1), var(--shadow);
}

[data-theme='dark'] .client-meta {
  border-top-color: #1f3151;
}

[data-theme='dark'] .vehicle-card {
  background: linear-gradient(145deg, #111827, #0f1e35);
  border: 1px solid #1f3151;
}

[data-theme='dark'] .vehicle-card:hover {
  border-color: rgba(59, 130, 246, 0.3);
  box-shadow: 0 0 0 1px rgba(59,130,246,0.1), var(--shadow);
}

[data-theme='dark'] .history-item {
  background: #0d1829;
  border: 1px solid #1f3151;
}

[data-theme='dark'] .login-container {
  background: linear-gradient(135deg, #080e1a 0%, #0d1829 50%, #111827 100%);
}

[data-theme='dark'] .login-card {
  background: linear-gradient(145deg, #111827, #0f1e35);
  border-color: #1f3151;
  box-shadow: 0 40px 80px -12px rgb(0 0 0 / 0.7), 0 0 0 1px rgba(59,130,246,0.06);
}

/* Main Layout */
.dashboard-container {
  display: flex;
  min-height: 100vh;
}

/* Sidebar */
.sidebar {
  width: 280px;
  background: var(--bg-card);
  border-right: 1px solid var(--border);
  padding: 2rem 1.5rem;
  display: flex;
  flex-direction: column;
  position: sticky;
  top: 0;
  height: 100vh;
  z-index: 100;
  transition: background 0.3s, border-color 0.3s, box-shadow 0.3s;
}

.logo-section {
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 3rem;
  padding: 0 0.5rem;
}

.logo-circle {
  width: 40px;
  height: 40px;
  background: var(--primary);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: white;
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.2);
}

.logo-text {
  font-size: 1.5rem;
  font-weight: 700;
  letter-spacing: -1px;
  color: var(--text-primary);
}

.nav-menu {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.nav-item {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.8rem 1rem;
  color: var(--text-secondary);
  text-decoration: none;
  border-radius: 12px;
  transition: var(--transition);
  cursor: pointer;
  font-weight: 500;
}

.nav-item:hover {
  background: var(--bg-main);
  color: var(--primary);
}

.nav-item.active {
  background: var(--primary-light);
  color: var(--primary);
  border: 1px solid rgba(37, 99, 235, 0.1);
}

/* Main Content */
.main-content {
  flex: 1 1;
  padding: 2.5rem;
  background: var(--bg-main);
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2.5rem;
}

.welcome-section h1 {
  font-size: 1.875rem;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 0.25rem;
}

.welcome-section p {
  color: var(--text-secondary);
}

/* Dashboard Cards */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 1.5rem;
  margin-bottom: 2.5rem;
}

.stat-card {
  background: var(--bg-card);
  border: 1px solid var(--border);
  padding: 1.5rem;
  border-radius: 20px;
  transition: var(--transition);
  box-shadow: var(--shadow-sm);
}

.stat-card:hover {
  transform: translateY(-2px);
  box-shadow: var(--shadow);
  border-color: var(--primary-light);
}

.stat-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1rem;
}

.stat-icon {
  width: 48px;
  height: 48px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.25rem;
  background: var(--primary-light);
  color: var(--primary);
}

.stat-value {
  font-size: 1.875rem;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 0.25rem;
}

.stat-label {
  color: var(--text-secondary);
  font-size: 0.875rem;
  font-weight: 500;
}

/* Charts Region */
.chart-container {
  background: var(--bg-card);
  border: 1px solid var(--border);
  padding: 2rem;
  border-radius: 24px;
  margin-bottom: 2rem;
  box-shadow: var(--shadow-sm);
}

/* Forms */
.glass-form {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 2rem;
  background: var(--bg-card);
  padding: 1.25rem;
  border-radius: 16px;
  border: 1px solid var(--border);
  box-shadow: var(--shadow-sm);
}

.glass-input {
  background: var(--bg-input);
  border: 1px solid var(--border);
  padding: 0.75rem 1rem;
  border-radius: 10px;
  color: var(--text-primary);
  width: 220px;
  transition: var(--transition);
  font-size: 0.95rem;
}

.glass-input:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.btn-primary {
  background: var(--primary);
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  border-radius: 10px;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition);
  box-shadow: 0 4px 10px rgba(37, 99, 235, 0.2);
}

.btn-primary:hover {
  transform: translateY(-1px);
  background: #1d4ed8;
  box-shadow: 0 6px 15px rgba(37, 99, 235, 0.3);
}

/* Tables */
.table-wrapper {
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 20px;
  overflow: hidden;
  box-shadow: var(--shadow-sm);
}

table {
  width: 100%;
  border-collapse: collapse;
}

th {
  background: var(--bg-surface);
  text-align: left;
  padding: 1rem 1.5rem;
  font-weight: 600;
  color: var(--text-secondary);
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 1px solid var(--border);
  transition: background 0.3s;
}

td {
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid var(--border);
  font-size: 0.95rem;
  color: var(--text-primary);
}

tr:last-child td {
  border-bottom: none;
}

tr:hover td {
  background: var(--bg-surface);
}

/* Login Page Professional */
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);
}

.login-card {
  background: var(--bg-card);
  padding: 3rem;
  border-radius: 32px;
  border: 1px solid var(--border);
  width: 100%;
  max-width: 450px;
  box-shadow: var(--shadow-md);
  text-align: center;
}

.login-card h2 {
  font-size: 2rem;
  font-weight: 800;
  margin-bottom: 0.5rem;
  color: var(--text-primary);
}

.login-card p {
  color: var(--text-secondary);
  margin-bottom: 2rem;
}

.login-input-group {
  margin-bottom: 1.25rem;
  text-align: left;
}

.login-input-group label {
  display: block;
  margin-bottom: 0.5rem;
  color: var(--text-primary);
  font-size: 0.875rem;
  font-weight: 600;
}

.login-input {
  width: 100%;
  background: var(--bg-input);
  border: 1px solid var(--border);
  padding: 0.875rem 1.25rem;
  border-radius: 12px;
  color: var(--text-primary);
  font-size: 1rem;
  transition: var(--transition);
}

.login-input:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

.login-btn {
  width: 100%;
  margin-top: 1rem;
}

/* Animations */
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

.animate-fade {
  animation: fadeIn 0.4s ease-out forwards;
}

/* Modal System - Clean Modern */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(15, 23, 42, 0.4);
  backdrop-filter: blur(4px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 1.5rem;
}

.modal-container {
  background: var(--bg-card);
  border: 1px solid var(--border);
  border-radius: 24px;
  width: 100%;
  max-width: 500px;
  padding: 2rem;
  box-shadow: var(--shadow-md);
  position: relative;
  animation: modalScale 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes modalScale {
  from { opacity: 0; transform: scale(0.95); }
  to { opacity: 1; transform: scale(1); }
}

.modal-header {
  margin-bottom: 1.5rem;
}

.modal-header h3 {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--text-primary);
}

.form-group {
  margin-bottom: 1.25rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  color: var(--text-primary);
  font-size: 0.875rem;
  font-weight: 600;
}

.input-field {
  width: 100%;
  background: var(--bg-input);
  border: 1px solid var(--border);
  padding: 0.75rem 1rem;
  border-radius: 10px;
  color: var(--text-primary);
  font-size: 0.95rem;
  transition: var(--transition);
}

.input-field:focus {
  outline: none;
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);
}

select.input-field option {
  background: var(--bg-card);
  color: var(--text-primary);
}

.modal-actions {
  display: flex;
  gap: 0.75rem;
  justify-content: flex-end;
  margin-top: 2rem;
}

.btn-secondary {
  background: var(--bg-card);
  color: var(--text-secondary);
  border: 1px solid var(--border);
  padding: 0.75rem 1.25rem;
  border-radius: 10px;
  font-weight: 600;
  cursor: pointer;
  transition: var(--transition);
}

.btn-secondary:hover {
  background: var(--bg-surface);
  color: var(--text-primary);
}



/* Client & Vehicle cards */
        .client-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(320px, 1fr)); gap: 1.5rem; }
        .client-card { background: var(--white); border-radius: 16px; padding: 1.5rem; box-shadow: var(--shadow); transition: all 0.2s; cursor: pointer; border: 2px solid transparent; }
        .client-card:hover { transform: translateY(-2px); box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1); border-color: rgb(14 165 233 / 0.2); }
        .client-header { display: flex; align-items: center; gap: 1rem; margin-bottom: 1rem; }
        .client-avatar { width: 56px; height: 56px; border-radius: 50%; background: linear-gradient(135deg, var(--primary), var(--purple)); display: flex; align-items: center; justify-content: center; color: white; font-size: 1.25rem; font-weight: 700; }
        .client-info h4 { font-size: 1.1rem; margin-bottom: 0.25rem; }
        .client-info p { font-size: 0.8rem; color: var(--gray); }
        .client-meta { display: flex; gap: 1rem; margin-top: 1rem; padding-top: 1rem; border-top: 1px solid var(--border); }
        .client-meta-item { text-align: center; flex: 1 1; }
        .client-meta-item .value { font-size: 1.25rem; font-weight: 700; color: var(--primary); }
        .client-meta-item .label { font-size: 0.7rem; color: var(--gray); text-transform: uppercase; }
        .client-tags { display: flex; gap: 0.5rem; margin-top: 0.75rem; flex-wrap: wrap; }
        .tag { padding: 0.25rem 0.5rem; border-radius: 6px; font-size: 0.7rem; font-weight: 600; background: var(--light); color: var(--gray); }
        .tag.vip { background: rgb(245 158 11 / 0.15); color: var(--warning); }
        .tag.novo { background: rgb(16 185 129 / 0.15); color: var(--success); }

        .vehicle-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(420px, 1fr)); gap: 0.6rem; }
        .vehicle-card { background: var(--white); border-radius: 16px; overflow: hidden; box-shadow: var(--shadow); transition: all 0.2s; }
        .vehicle-card:hover { transform: translateY(-2px); box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1); }
        .vehicle-image { height: 140px; background: linear-gradient(135deg, #1e293b, #334155); display: flex; align-items: center; justify-content: center; color: white; font-size: 3rem; position: relative; }
        .vehicle-plate { position: absolute; bottom: -12px; left: 1.5rem; background: #ffeb3b; color: #1a1a1a; padding: 0.35rem 0.75rem; border-radius: 6px; font-weight: 700; font-size: 0.9rem; letter-spacing: 1px; box-shadow: 0 2px 4px rgb(0 0 0 / 0.2); }
        .vehicle-body { padding: 1.75rem 1.5rem 1.5rem; }
        .vehicle-title { font-size: 1.1rem; margin-bottom: 0.25rem; }
        .vehicle-sub { font-size: 0.8rem; color: var(--gray); margin-bottom: 1rem; }
        .vehicle-stats { display: grid; grid-template-columns: repeat(3, 1fr); gap: 0.75rem; margin-bottom: 1rem; }
        .v-stat { text-align: center; padding: 0.75rem; background: var(--light); border-radius: 10px; }
        .v-stat .num { font-size: 1.1rem; font-weight: 700; color: var(--dark); }
        .v-stat .lbl { font-size: 0.65rem; color: var(--gray); text-transform: uppercase; margin-top: 0.25rem; }
        .vehicle-alert { display: flex; align-items: center; gap: 0.5rem; padding: 0.625rem 0.875rem; border-radius: 8px; font-size: 0.8rem; font-weight: 600; margin-bottom: 1rem; }
        .vehicle-alert.ok { background: rgb(16 185 129 / 0.1); color: var(--success); }
        .vehicle-alert.warn { background: rgb(245 158 11 / 0.1); color: var(--warning); }
        .vehicle-alert.danger { background: rgb(239 68 68 / 0.1); color: var(--danger); }
        .vehicle-actions { display: flex; gap: 0.5rem; }
        .vehicle-actions .btn { flex: 1 1; justify-content: center; }

        /* Detail panel */
        .detail-panel { position: fixed; top: 0; right: -480px; width: 480px; height: 100vh; background: var(--bg-card); box-shadow: -10px 0 25px rgb(0 0 0 / 0.1); z-index: 150; transition: right 0.3s ease, background 0.3s, box-shadow 0.3s; overflow-y: auto; overscroll-behavior: contain; }
        .detail-panel.open { right: 0; }
        .detail-header { padding: 1.5rem; border-bottom: 1px solid var(--border); display: flex; justify-content: space-between; align-items: center; }
        .detail-body { padding: 1.5rem; }
        .overlay-backdrop { position: fixed; inset: 0; background: rgb(0 0 0 / 0.3); z-index: 140; display: none; }
        .overlay-backdrop.active { display: block; }

        .history-list { margin-top: 1rem; }
        .history-item { display: flex; gap: 1rem; padding: 1rem; background: var(--light); border-radius: 10px; margin-bottom: 0.75rem; }
        .history-date { text-align: center; min-width: 50px; }
        .history-date .day { font-size: 1.25rem; font-weight: 700; color: var(--primary); }
        .history-date .month { font-size: 0.65rem; color: var(--gray); text-transform: uppercase; }
        .history-content { flex: 1 1; }
        .history-content h5 { font-size: 0.9rem; margin-bottom: 0.25rem; }
        .history-content p { font-size: 0.8rem; color: var(--gray); }
        .history-price { font-weight: 700; color: var(--success); }

        /* Modal */
        .modal-overlay { position: fixed; inset: 0; background: rgb(0 0 0 / 0.5); backdrop-filter: blur(4px); display: none; align-items: center; justify-content: center; z-index: 100; }
        .modal-overlay.active { display: flex; }
        .modal { background: var(--bg-card); border-radius: 20px; width: 100%; max-width: 560px; max-height: 90vh; overflow-y: auto; box-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25); animation: slideUp 0.3s ease; transition: background 0.3s; }
        @keyframes slideUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }
        .modal-header { padding: 1.5rem; border-bottom: 1px solid var(--border); display: flex; justify-content: space-between; align-items: center; }
        .modal-header h3 { font-size: 1.25rem; }
        .close-btn { background: none; border: none; font-size: 1.5rem; cursor: pointer; color: var(--gray); width: 36px; height: 36px; border-radius: 8px; display: flex; align-items: center; justify-content: center; }
        .close-btn:hover { background: var(--bg-surface); }
        .modal-body { padding: 1.5rem; }
        .form-row { display: grid; grid-template-columns: 1fr 1fr; gap: 1rem; margin-bottom: 1rem; }
        .form-group { margin-bottom: 1rem; }
        .form-group label { display: block; font-size: 0.875rem; font-weight: 600; margin-bottom: 0.5rem; color: #334155; }
        .form-group input, .form-group select { width: 100%; padding: 0.625rem 0.875rem; border: 2px solid var(--border); background: var(--bg-input); color: var(--text-primary); border-radius: 10px; font-size: 0.875rem; transition: all 0.2s; }
        .form-group input:focus, .form-group select:focus { outline: none; border-color: var(--primary); }
        .whatsapp-preview { background: #dcf8c6; padding: 1rem; border-radius: 12px; margin-top: 1rem; border-left: 4px solid #25d366; font-size: 0.875rem; line-height: 1.5; }
        .whatsapp-preview strong { color: #075e54; }

        /* Toast */
        .toast-container { position: fixed; top: 2rem; right: 2rem; z-index: 200; display: flex; flex-direction: column; gap: 0.75rem; }
        .toast { background: var(--bg-card); padding: 1rem 1.5rem; border-radius: 12px; box-shadow: var(--shadow-md); display: flex; align-items: center; gap: 0.75rem; animation: slideIn 0.3s ease; border-left: 4px solid var(--success); min-width: 320px; border: 1px solid var(--border); border-left-width: 4px; }
        .toast.error { border-left-color: var(--danger); }
        .toast.info { border-left-color: var(--primary); }
        @keyframes slideIn { from { transform: translateX(100%); opacity: 0; } to { transform: translateX(0); opacity: 1; } }
        .toast-icon { width: 36px; height: 36px; border-radius: 50%; background: rgb(16 185 129 / 0.1); display: flex; align-items: center; justify-content: center; color: var(--success); }
        .toast.error .toast-icon { background: rgb(239 68 68 / 0.1); color: var(--danger); }
        .toast.info .toast-icon { background: rgb(14 165 233 / 0.1); color: var(--primary); }

/* ── AI Modal ─────────────────────────────────────────────── */
@keyframes aiSpin { to { transform: rotate(360deg); } }
@keyframes aiPulse { 0%,80%,100% { transform:scale(0.6);opacity:0.35; } 40% { transform:scale(1);opacity:1; } }
@keyframes aiSlideUp { from { opacity:0; transform:translateY(24px) scale(0.97); } to { opacity:1; transform:translateY(0) scale(1); } }
.ai-spinner { width:56px; height:56px; border-radius:50%; border:3px solid rgba(167,139,250,0.2); border-top-color:#a78bfa; animation:aiSpin 0.85s linear infinite; }
.ai-dot { width:8px; height:8px; border-radius:50%; background:#a78bfa; animation:aiPulse 1.4s ease-in-out infinite; }
.ai-glass { background:rgba(255,255,255,0.07); backdrop-filter:blur(32px); -webkit-backdrop-filter:blur(32px); border:1px solid rgba(255,255,255,0.15); border-radius:24px; animation:aiSlideUp 0.3s cubic-bezier(0.34,1.56,0.64,1); }
.ai-result-line { display:flex; gap:0.5rem; margin-bottom:0.55rem; align-items:flex-start; font-size:0.875rem; line-height:1.65; color:rgba(255,255,255,0.88); }
        
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,wBAAwB;EACxB,uCAAuC;EACvC,oBAAoB;EACpB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;;EAEjB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,eAAe;;EAEf,SAAS;EACT,uBAAuB;EACvB,yBAAyB;;EAEzB,oBAAoB;EACpB,iBAAiB;EACjB,iCAAiC;EACjC,wCAAwC;;EAExC,YAAY;EACZ,mDAAmD;EACnD,0CAA0C;EAC1C,0EAA0E;EAC1E,+EAA+E;EAC/E,gDAAgD;AAClD;;AAEA;;wDAEwD;AACxD;EACE,sBAAsB;EACtB,kBAAkB;EAClB,yCAAyC;EACzC,wCAAwC;EACxC,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;;EAEjB,oCAAoC;EACpC,kBAAkB,UAAU,6BAA6B;EACzD,kBAAkB,UAAU,oBAAoB;EAChD,qBAAqB,OAAO,uCAAuC;EACnE,mBAAmB,SAAS,oBAAoB;EAChD,gBAAgB,YAAY,mCAAmC;EAC/D,gBAAgB,YAAY,mCAAmC;EAC/D,eAAe,aAAa,2CAA2C;EACvE,eAAe;;EAEf,SAAS;EACT,uBAAuB;EACvB,yBAAyB;;EAEzB,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;EAC/B,wCAAwC;;EAExC,sCAAsC;EACtC,yCAAyC;EACzC,4EAA4E;EAC5E,iFAAiF;EACjF,+CAA+C;AACjD;;AAEA;EACE,SAAS;EACT,UAAU;EACV,sBAAsB;EACtB,iCAAiC;AACnC;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;EAC1B,iBAAiB;EACjB,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA,cAAc;AACd;EACE,UAAU;AACZ;AACA;EACE,uBAAuB;AACzB;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,iCAAiC;AACnC;;AAEA,yDAAyD;AACzD;EACE,6DAA6D;EAC7D,2BAA2B;EAC3B,uCAAuC;AACzC;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,cAAc;EACd,iCAAiC;AACnC;;AAEA;EACE,qDAAqD;EACrD,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;EACrC,4DAA4D;AAC9D;;AAEA;EACE,qDAAqD;EACrD,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6DAA6D;EAC7D,0CAA0C;EAC1C,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,qDAAqD;EACrD,yBAAyB;EACzB,+EAA+E;AACjF;;AAEA;EACE,4BAA4B;EAC5B,iCAAiC;AACnC;;AAEA;EACE,qDAAqD;EACrD,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,qDAAqD;EACrD,qBAAqB;AACvB;;AAEA;;;;;EAKE,mBAAmB;EACnB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;;;;;EAKE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,qDAAqD;EACrD,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,qDAAqD;EACrD,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;EACrC,yDAAyD;AAC3D;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,yDAAyD;AAC3D;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,0EAA0E;AAC5E;;AAEA;EACE,qDAAqD;EACrD,qBAAqB;EACrB,+EAA+E;AACjF;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA,YAAY;AACZ;EACE,YAAY;EACZ,0BAA0B;EAC1B,qCAAqC;EACrC,oBAAoB;EACpB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,YAAY;EACZ,+DAA+D;AACjE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;EAC1B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;EAChC,qBAAqB;EACrB,wCAAwC;AAC1C;;AAEA,iBAAiB;AACjB;EACE,SAAO;EACP,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,2DAA2D;EAC3D,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,eAAe;EACf,mBAAmB;EACnB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gCAAgC;EAChC,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;EAC1B,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA,UAAU;AACV;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,+BAA+B;EAC/B,qBAAqB;EACrB,mBAAmB;EACnB,0BAA0B;EAC1B,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,4CAA4C;AAC9C;;AAEA;EACE,0BAA0B;EAC1B,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,6CAA6C;AAC/C;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA,WAAW;AACX;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,sCAAsC;EACtC,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,6DAA6D;AAC/D;;AAEA;EACE,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,+BAA+B;EAC/B,WAAW;EACX,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,+BAA+B;EAC/B,yBAAyB;EACzB,mBAAmB;EACnB,0BAA0B;EAC1B,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA,gCAAgC;AAChC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,iCAAiC;EACjC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,0BAA0B;EAC1B,+BAA+B;EAC/B,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,4BAA4B;EAC5B,kBAAkB;EAClB,4DAA4D;AAC9D;;AAEA;EACE,OAAO,UAAU,EAAE,sBAAsB,EAAE;EAC3C,KAAK,UAAU,EAAE,mBAAmB,EAAE;AACxC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,+BAA+B;EAC/B,qBAAqB;EACrB,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,4CAA4C;AAC9C;;AAEA;EACE,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,+BAA+B;EAC/B,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;;;;AAIA,2BAA2B;QACnB,eAAe,aAAa,EAAE,4DAA4D,EAAE,WAAW,EAAE;QACzG,eAAe,wBAAwB,EAAE,mBAAmB,EAAE,eAAe,EAAE,yBAAyB,EAAE,oBAAoB,EAAE,eAAe,EAAE,6BAA6B,EAAE;QAChL,qBAAqB,2BAA2B,EAAE,6CAA6C,EAAE,mCAAmC,EAAE;QACtI,iBAAiB,aAAa,EAAE,mBAAmB,EAAE,SAAS,EAAE,mBAAmB,EAAE;QACrF,iBAAiB,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,kEAAkE,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,YAAY,EAAE,kBAAkB,EAAE,gBAAgB,EAAE;QACrP,kBAAkB,iBAAiB,EAAE,sBAAsB,EAAE;QAC7D,iBAAiB,iBAAiB,EAAE,kBAAkB,EAAE;QACxD,eAAe,aAAa,EAAE,SAAS,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,mCAAmC,EAAE;QACnH,oBAAoB,kBAAkB,EAAE,SAAO,EAAE;QACjD,2BAA2B,kBAAkB,EAAE,gBAAgB,EAAE,qBAAqB,EAAE;QACxF,2BAA2B,iBAAiB,EAAE,kBAAkB,EAAE,yBAAyB,EAAE;QAC7F,eAAe,aAAa,EAAE,WAAW,EAAE,mBAAmB,EAAE,eAAe,EAAE;QACjF,OAAO,uBAAuB,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,wBAAwB,EAAE,kBAAkB,EAAE;QACvI,WAAW,kCAAkC,EAAE,qBAAqB,EAAE;QACtE,YAAY,kCAAkC,EAAE,qBAAqB,EAAE;;QAEvE,gBAAgB,aAAa,EAAE,4DAA4D,EAAE,WAAW,EAAE;QAC1G,gBAAgB,wBAAwB,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,yBAAyB,EAAE,oBAAoB,EAAE;QAClI,sBAAsB,2BAA2B,EAAE,6CAA6C,EAAE;QAClG,iBAAiB,aAAa,EAAE,qDAAqD,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,YAAY,EAAE,eAAe,EAAE,kBAAkB,EAAE;QACvM,iBAAiB,kBAAkB,EAAE,aAAa,EAAE,YAAY,EAAE,mBAAmB,EAAE,cAAc,EAAE,wBAAwB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,mBAAmB,EAAE,sCAAsC,EAAE;QACvP,gBAAgB,8BAA8B,EAAE;QAChD,iBAAiB,iBAAiB,EAAE,sBAAsB,EAAE;QAC5D,eAAe,iBAAiB,EAAE,kBAAkB,EAAE,mBAAmB,EAAE;QAC3E,iBAAiB,aAAa,EAAE,qCAAqC,EAAE,YAAY,EAAE,mBAAmB,EAAE;QAC1G,UAAU,kBAAkB,EAAE,gBAAgB,EAAE,wBAAwB,EAAE,mBAAmB,EAAE;QAC/F,eAAe,iBAAiB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE;QACxE,eAAe,kBAAkB,EAAE,kBAAkB,EAAE,yBAAyB,EAAE,mBAAmB,EAAE;QACvG,iBAAiB,aAAa,EAAE,mBAAmB,EAAE,WAAW,EAAE,0BAA0B,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,mBAAmB,EAAE;QAC5K,oBAAoB,iCAAiC,EAAE,qBAAqB,EAAE;QAC9E,sBAAsB,iCAAiC,EAAE,qBAAqB,EAAE;QAChF,wBAAwB,gCAAgC,EAAE,oBAAoB,EAAE;QAChF,mBAAmB,aAAa,EAAE,WAAW,EAAE;QAC/C,wBAAwB,SAAO,EAAE,uBAAuB,EAAE;;QAE1D,iBAAiB;QACjB,gBAAgB,eAAe,EAAE,MAAM,EAAE,aAAa,EAAE,YAAY,EAAE,aAAa,EAAE,0BAA0B,EAAE,yCAAyC,EAAE,YAAY,EAAE,6DAA6D,EAAE,gBAAgB,EAAE,4BAA4B,EAAE;QACzR,qBAAqB,QAAQ,EAAE;QAC/B,iBAAiB,eAAe,EAAE,sCAAsC,EAAE,aAAa,EAAE,8BAA8B,EAAE,mBAAmB,EAAE;QAC9I,eAAe,eAAe,EAAE;QAChC,oBAAoB,eAAe,EAAE,QAAQ,EAAE,4BAA4B,EAAE,YAAY,EAAE,aAAa,EAAE;QAC1G,2BAA2B,cAAc,EAAE;;QAE3C,gBAAgB,gBAAgB,EAAE;QAClC,gBAAgB,aAAa,EAAE,SAAS,EAAE,aAAa,EAAE,wBAAwB,EAAE,mBAAmB,EAAE,sBAAsB,EAAE;QAChI,gBAAgB,kBAAkB,EAAE,eAAe,EAAE;QACrD,qBAAqB,kBAAkB,EAAE,gBAAgB,EAAE,qBAAqB,EAAE;QAClF,uBAAuB,kBAAkB,EAAE,kBAAkB,EAAE,yBAAyB,EAAE;QAC1F,mBAAmB,SAAO,EAAE;QAC5B,sBAAsB,iBAAiB,EAAE,sBAAsB,EAAE;QACjE,qBAAqB,iBAAiB,EAAE,kBAAkB,EAAE;QAC5D,iBAAiB,gBAAgB,EAAE,qBAAqB,EAAE;;QAE1D,UAAU;QACV,iBAAiB,eAAe,EAAE,QAAQ,EAAE,4BAA4B,EAAE,0BAA0B,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,YAAY,EAAE;QACjL,wBAAwB,aAAa,EAAE;QACvC,SAAS,0BAA0B,EAAE,mBAAmB,EAAE,WAAW,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,+CAA+C,EAAE,4BAA4B,EAAE,2BAA2B,EAAE;QACzO,qBAAqB,OAAO,UAAU,EAAE,2BAA2B,EAAE,EAAE,KAAK,UAAU,EAAE,wBAAwB,EAAE,EAAE;QACpH,gBAAgB,eAAe,EAAE,sCAAsC,EAAE,aAAa,EAAE,8BAA8B,EAAE,mBAAmB,EAAE;QAC7I,mBAAmB,kBAAkB,EAAE;QACvC,aAAa,gBAAgB,EAAE,YAAY,EAAE,iBAAiB,EAAE,eAAe,EAAE,kBAAkB,EAAE,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE;QACjN,mBAAmB,6BAA6B,EAAE;QAClD,cAAc,eAAe,EAAE;QAC/B,YAAY,aAAa,EAAE,8BAA8B,EAAE,SAAS,EAAE,mBAAmB,EAAE;QAC3F,cAAc,mBAAmB,EAAE;QACnC,oBAAoB,cAAc,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,qBAAqB,EAAE,cAAc,EAAE;QAClH,wCAAwC,WAAW,EAAE,0BAA0B,EAAE,+BAA+B,EAAE,2BAA2B,EAAE,0BAA0B,EAAE,mBAAmB,EAAE,mBAAmB,EAAE,oBAAoB,EAAE;QAC3O,oDAAoD,aAAa,EAAE,4BAA4B,EAAE;QACjG,oBAAoB,mBAAmB,EAAE,aAAa,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,8BAA8B,EAAE,mBAAmB,EAAE,gBAAgB,EAAE;QACtK,2BAA2B,cAAc,EAAE;;QAE3C,UAAU;QACV,mBAAmB,eAAe,EAAE,SAAS,EAAE,WAAW,EAAE,YAAY,EAAE,aAAa,EAAE,sBAAsB,EAAE,YAAY,EAAE;QAC/H,SAAS,0BAA0B,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,4BAA4B,EAAE,aAAa,EAAE,mBAAmB,EAAE,YAAY,EAAE,4BAA4B,EAAE,qCAAqC,EAAE,gBAAgB,EAAE,+BAA+B,EAAE,sBAAsB,EAAE;QAChT,eAAe,gCAAgC,EAAE;QACjD,cAAc,iCAAiC,EAAE;QACjD,qBAAqB,OAAO,2BAA2B,EAAE,UAAU,EAAE,EAAE,KAAK,wBAAwB,EAAE,UAAU,EAAE,EAAE;QACpH,cAAc,WAAW,EAAE,YAAY,EAAE,kBAAkB,EAAE,iCAAiC,EAAE,aAAa,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,qBAAqB,EAAE;QACpL,2BAA2B,gCAAgC,EAAE,oBAAoB,EAAE;QACnF,0BAA0B,iCAAiC,EAAE,qBAAqB,EAAE;;AAE5F,gEAAgE;AAChE,oBAAoB,KAAK,yBAAyB,EAAE,EAAE;AACtD,qBAAqB,cAAc,oBAAoB,CAAC,YAAY,EAAE,EAAE,MAAM,kBAAkB,CAAC,SAAS,EAAE,EAAE;AAC9G,uBAAuB,OAAO,SAAS,EAAE,sCAAsC,EAAE,EAAE,KAAK,SAAS,EAAE,gCAAgC,EAAE,EAAE;AACvI,cAAc,UAAU,EAAE,WAAW,EAAE,iBAAiB,EAAE,sCAAsC,EAAE,wBAAwB,EAAE,sCAAsC,EAAE;AACpK,UAAU,SAAS,EAAE,UAAU,EAAE,iBAAiB,EAAE,kBAAkB,EAAE,2CAA2C,EAAE;AACrH,YAAY,iCAAiC,EAAE,0BAA0B,EAAE,kCAAkC,EAAE,uCAAuC,EAAE,kBAAkB,EAAE,uDAAuD,EAAE;AACrO,kBAAkB,YAAY,EAAE,UAAU,EAAE,qBAAqB,EAAE,sBAAsB,EAAE,kBAAkB,EAAE,gBAAgB,EAAE,4BAA4B,EAAE","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Outfit:wght@300;400;500;600;700&display=swap');\n\n:root {\n  /* Brand */\n  --primary: #2563eb;\n  --primary-light: #dbeafe;\n  --primary-glow: rgba(37, 99, 235, 0.25);\n  --secondary: #fbbf24;\n  --accent: #2563eb;\n  --purple: #8b5cf6;\n  --success: #10b981;\n  --warning: #f59e0b;\n  --danger: #ef4444;\n\n  /* Surfaces */\n  --bg-main: #f8fafc;\n  --bg-card: #ffffff;\n  --bg-surface: #f1f5f9;\n  --bg-input: #ffffff;\n  --white: #ffffff;\n  --light: #f1f5f9;\n  --dark: #1e293b;\n  --gray: #64748b;\n\n  /* Text */\n  --text-primary: #1e293b;\n  --text-secondary: #64748b;\n\n  /* Borders & Glass */\n  --border: #e2e8f0;\n  --glass: rgba(255, 255, 255, 0.8);\n  --glass-border: rgba(226, 232, 240, 0.8);\n\n  /* Shadows */\n  --transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  --shadow-sm: 0 1px 2px 0 rgb(0 0 0 / 0.05);\n  --shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);\n  --shadow-md: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);\n  --shadow-lg: 0 25px 50px -12px rgb(0 0 0 / 0.25);\n}\n\n/* ══════════════════════════════════════════════════════\n   DARK THEME — Visual completo com profundidade real\n══════════════════════════════════════════════════════ */\n[data-theme='dark'] {\n  /* Brand adjustments */\n  --primary: #3b82f6;\n  --primary-light: rgba(59, 130, 246, 0.18);\n  --primary-glow: rgba(59, 130, 246, 0.35);\n  --purple: #a78bfa;\n  --success: #34d399;\n  --warning: #fbbf24;\n  --danger: #f87171;\n\n  /* Surfaces — 3 níveis de elevação */\n  --bg-main: #080e1a;         /* fundo base — quase preto */\n  --bg-card: #111827;         /* cards / sidebar */\n  --bg-surface: #1c2a3f;      /* linhas hover, table header, inputs */\n  --bg-input: #0f172a;        /* fundo de inputs */\n  --white: #111827;           /* onde o código usa var(--white) */\n  --light: #1c2a3f;           /* onde o código usa var(--light) */\n  --dark: #e2e8f0;            /* onde o código usa var(--dark) p/ texto */\n  --gray: #94a3b8;\n\n  /* Text */\n  --text-primary: #e2e8f0;\n  --text-secondary: #7c8fa8;\n\n  /* Borders */\n  --border: #1f3151;\n  --glass: rgba(17, 24, 39, 0.92);\n  --glass-border: rgba(59, 130, 246, 0.12);\n\n  /* Shadows — mais intensas no escuro */\n  --shadow-sm: 0 1px 3px 0 rgb(0 0 0 / 0.6);\n  --shadow: 0 8px 20px -4px rgb(0 0 0 / 0.55), 0 2px 6px -2px rgb(0 0 0 / 0.4);\n  --shadow-md: 0 20px 40px -8px rgb(0 0 0 / 0.65), 0 6px 12px -4px rgb(0 0 0 / 0.5);\n  --shadow-lg: 0 40px 80px -16px rgb(0 0 0 / 0.8);\n}\n\n* {\n  margin: 0;\n  padding: 0;\n  box-sizing: border-box;\n  font-family: 'Outfit', sans-serif;\n}\n\nbody {\n  background: var(--bg-main);\n  color: var(--text-primary);\n  min-height: 100vh;\n  overflow-x: hidden;\n  -webkit-font-smoothing: antialiased;\n}\n\n/* Scrollbar */\n::-webkit-scrollbar {\n  width: 6px;\n}\n::-webkit-scrollbar-track {\n  background: transparent;\n}\n::-webkit-scrollbar-thumb {\n  background: var(--border);\n  border-radius: 10px;\n}\n::-webkit-scrollbar-thumb:hover {\n  background: var(--text-secondary);\n}\n\n/* Dark theme — sidebar e cards com borda sutil azulada */\n[data-theme='dark'] .sidebar {\n  background: linear-gradient(180deg, #111827 0%, #0d1829 100%);\n  border-right-color: #1f3151;\n  box-shadow: 4px 0 24px rgb(0 0 0 / 0.4);\n}\n\n[data-theme='dark'] .nav-item:hover {\n  background: rgba(59, 130, 246, 0.08);\n  color: #60a5fa;\n}\n\n[data-theme='dark'] .nav-item.active {\n  background: rgba(59, 130, 246, 0.15);\n  border-color: rgba(59, 130, 246, 0.25);\n  color: #60a5fa;\n  box-shadow: inset 3px 0 0 #3b82f6;\n}\n\n[data-theme='dark'] .stat-card {\n  background: linear-gradient(145deg, #111827, #0f1e35);\n  border-color: #1f3151;\n}\n\n[data-theme='dark'] .stat-card:hover {\n  border-color: rgba(59, 130, 246, 0.3);\n  box-shadow: 0 0 0 1px rgba(59, 130, 246, 0.1), var(--shadow);\n}\n\n[data-theme='dark'] .chart-container {\n  background: linear-gradient(145deg, #111827, #0f1e35);\n  border-color: #1f3151;\n}\n\n[data-theme='dark'] .table-wrapper {\n  background: #111827;\n  border-color: #1f3151;\n}\n\n[data-theme='dark'] th {\n  background: #0d1829;\n  color: #60a5fa;\n  border-bottom-color: #1f3151;\n}\n\n[data-theme='dark'] tr:hover td {\n  background: rgba(59, 130, 246, 0.04);\n}\n\n[data-theme='dark'] td {\n  border-bottom-color: #1a2744;\n}\n\n[data-theme='dark'] .detail-panel {\n  background: linear-gradient(180deg, #111827 0%, #0d1829 100%);\n  box-shadow: -12px 0 40px rgb(0 0 0 / 0.55);\n  border-left: 1px solid #1f3151;\n}\n\n[data-theme='dark'] .detail-header {\n  border-bottom-color: #1f3151;\n  background: rgba(13, 24, 41, 0.8);\n}\n\n[data-theme='dark'] .modal {\n  background: linear-gradient(145deg, #111827, #0f1e35);\n  border: 1px solid #1f3151;\n  box-shadow: 0 40px 80px -12px rgb(0 0 0 / 0.8), 0 0 0 1px rgba(59,130,246,0.06);\n}\n\n[data-theme='dark'] .modal-header {\n  border-bottom-color: #1f3151;\n  background: rgba(13, 24, 41, 0.5);\n}\n\n[data-theme='dark'] .modal-container {\n  background: linear-gradient(145deg, #111827, #0f1e35);\n  border-color: #1f3151;\n  box-shadow: 0 40px 80px -12px rgb(0 0 0 / 0.8);\n}\n\n[data-theme='dark'] .glass-form {\n  background: linear-gradient(145deg, #111827, #0f1e35);\n  border-color: #1f3151;\n}\n\n[data-theme='dark'] .glass-input,\n[data-theme='dark'] .input-field,\n[data-theme='dark'] .login-input,\n[data-theme='dark'] .form-group input,\n[data-theme='dark'] .form-group select {\n  background: #0a1626;\n  border-color: #1f3151;\n  color: var(--text-primary);\n}\n\n[data-theme='dark'] .glass-input:focus,\n[data-theme='dark'] .input-field:focus,\n[data-theme='dark'] .login-input:focus,\n[data-theme='dark'] .form-group input:focus,\n[data-theme='dark'] .form-group select:focus {\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);\n}\n\n[data-theme='dark'] .form-group select option {\n  background: #111827;\n  color: var(--text-primary);\n}\n\n[data-theme='dark'] .btn-secondary {\n  background: #1c2a3f;\n  border-color: #1f3151;\n  color: var(--text-secondary);\n}\n\n[data-theme='dark'] .btn-secondary:hover {\n  background: #243352;\n  color: var(--text-primary);\n  border-color: rgba(59,130,246,0.3);\n}\n\n[data-theme='dark'] .btn-primary {\n  box-shadow: 0 4px 15px rgba(59, 130, 246, 0.35);\n}\n\n[data-theme='dark'] .btn-primary:hover {\n  box-shadow: 0 6px 20px rgba(59, 130, 246, 0.5);\n}\n\n[data-theme='dark'] .toast {\n  background: linear-gradient(145deg, #111827, #0d1829);\n  border-color: #1f3151;\n  box-shadow: var(--shadow-md);\n}\n\n[data-theme='dark'] .client-card {\n  background: linear-gradient(145deg, #111827, #0f1e35);\n  border-color: #1f3151;\n}\n\n[data-theme='dark'] .client-card:hover {\n  border-color: rgba(59, 130, 246, 0.3);\n  box-shadow: 0 0 0 1px rgba(59,130,246,0.1), var(--shadow);\n}\n\n[data-theme='dark'] .client-meta {\n  border-top-color: #1f3151;\n}\n\n[data-theme='dark'] .vehicle-card {\n  background: linear-gradient(145deg, #111827, #0f1e35);\n  border: 1px solid #1f3151;\n}\n\n[data-theme='dark'] .vehicle-card:hover {\n  border-color: rgba(59, 130, 246, 0.3);\n  box-shadow: 0 0 0 1px rgba(59,130,246,0.1), var(--shadow);\n}\n\n[data-theme='dark'] .history-item {\n  background: #0d1829;\n  border: 1px solid #1f3151;\n}\n\n[data-theme='dark'] .login-container {\n  background: linear-gradient(135deg, #080e1a 0%, #0d1829 50%, #111827 100%);\n}\n\n[data-theme='dark'] .login-card {\n  background: linear-gradient(145deg, #111827, #0f1e35);\n  border-color: #1f3151;\n  box-shadow: 0 40px 80px -12px rgb(0 0 0 / 0.7), 0 0 0 1px rgba(59,130,246,0.06);\n}\n\n/* Main Layout */\n.dashboard-container {\n  display: flex;\n  min-height: 100vh;\n}\n\n/* Sidebar */\n.sidebar {\n  width: 280px;\n  background: var(--bg-card);\n  border-right: 1px solid var(--border);\n  padding: 2rem 1.5rem;\n  display: flex;\n  flex-direction: column;\n  position: sticky;\n  top: 0;\n  height: 100vh;\n  z-index: 100;\n  transition: background 0.3s, border-color 0.3s, box-shadow 0.3s;\n}\n\n.logo-section {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  margin-bottom: 3rem;\n  padding: 0 0.5rem;\n}\n\n.logo-circle {\n  width: 40px;\n  height: 40px;\n  background: var(--primary);\n  border-radius: 12px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n  color: white;\n  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.2);\n}\n\n.logo-text {\n  font-size: 1.5rem;\n  font-weight: 700;\n  letter-spacing: -1px;\n  color: var(--text-primary);\n}\n\n.nav-menu {\n  list-style: none;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.nav-item {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 0.8rem 1rem;\n  color: var(--text-secondary);\n  text-decoration: none;\n  border-radius: 12px;\n  transition: var(--transition);\n  cursor: pointer;\n  font-weight: 500;\n}\n\n.nav-item:hover {\n  background: var(--bg-main);\n  color: var(--primary);\n}\n\n.nav-item.active {\n  background: var(--primary-light);\n  color: var(--primary);\n  border: 1px solid rgba(37, 99, 235, 0.1);\n}\n\n/* Main Content */\n.main-content {\n  flex: 1;\n  padding: 2.5rem;\n  background: var(--bg-main);\n}\n\n.header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 2.5rem;\n}\n\n.welcome-section h1 {\n  font-size: 1.875rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin-bottom: 0.25rem;\n}\n\n.welcome-section p {\n  color: var(--text-secondary);\n}\n\n/* Dashboard Cards */\n.stats-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 1.5rem;\n  margin-bottom: 2.5rem;\n}\n\n.stat-card {\n  background: var(--bg-card);\n  border: 1px solid var(--border);\n  padding: 1.5rem;\n  border-radius: 20px;\n  transition: var(--transition);\n  box-shadow: var(--shadow-sm);\n}\n\n.stat-card:hover {\n  transform: translateY(-2px);\n  box-shadow: var(--shadow);\n  border-color: var(--primary-light);\n}\n\n.stat-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 1rem;\n}\n\n.stat-icon {\n  width: 48px;\n  height: 48px;\n  border-radius: 14px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.25rem;\n  background: var(--primary-light);\n  color: var(--primary);\n}\n\n.stat-value {\n  font-size: 1.875rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin-bottom: 0.25rem;\n}\n\n.stat-label {\n  color: var(--text-secondary);\n  font-size: 0.875rem;\n  font-weight: 500;\n}\n\n/* Charts Region */\n.chart-container {\n  background: var(--bg-card);\n  border: 1px solid var(--border);\n  padding: 2rem;\n  border-radius: 24px;\n  margin-bottom: 2rem;\n  box-shadow: var(--shadow-sm);\n}\n\n/* Forms */\n.glass-form {\n  display: flex;\n  gap: 1rem;\n  flex-wrap: wrap;\n  align-items: center;\n  margin-bottom: 2rem;\n  background: var(--bg-card);\n  padding: 1.25rem;\n  border-radius: 16px;\n  border: 1px solid var(--border);\n  box-shadow: var(--shadow-sm);\n}\n\n.glass-input {\n  background: var(--bg-input);\n  border: 1px solid var(--border);\n  padding: 0.75rem 1rem;\n  border-radius: 10px;\n  color: var(--text-primary);\n  width: 220px;\n  transition: var(--transition);\n  font-size: 0.95rem;\n}\n\n.glass-input:focus {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);\n}\n\n.btn-primary {\n  background: var(--primary);\n  color: white;\n  border: none;\n  padding: 0.75rem 1.5rem;\n  border-radius: 10px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: var(--transition);\n  box-shadow: 0 4px 10px rgba(37, 99, 235, 0.2);\n}\n\n.btn-primary:hover {\n  transform: translateY(-1px);\n  background: #1d4ed8;\n  box-shadow: 0 6px 15px rgba(37, 99, 235, 0.3);\n}\n\n/* Tables */\n.table-wrapper {\n  background: var(--bg-card);\n  border: 1px solid var(--border);\n  border-radius: 20px;\n  overflow: hidden;\n  box-shadow: var(--shadow-sm);\n}\n\ntable {\n  width: 100%;\n  border-collapse: collapse;\n}\n\nth {\n  background: var(--bg-surface);\n  text-align: left;\n  padding: 1rem 1.5rem;\n  font-weight: 600;\n  color: var(--text-secondary);\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  border-bottom: 1px solid var(--border);\n  transition: background 0.3s;\n}\n\ntd {\n  padding: 1.25rem 1.5rem;\n  border-bottom: 1px solid var(--border);\n  font-size: 0.95rem;\n  color: var(--text-primary);\n}\n\ntr:last-child td {\n  border-bottom: none;\n}\n\ntr:hover td {\n  background: var(--bg-surface);\n}\n\n/* Login Page Professional */\n.login-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n  background: linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%);\n}\n\n.login-card {\n  background: var(--bg-card);\n  padding: 3rem;\n  border-radius: 32px;\n  border: 1px solid var(--border);\n  width: 100%;\n  max-width: 450px;\n  box-shadow: var(--shadow-md);\n  text-align: center;\n}\n\n.login-card h2 {\n  font-size: 2rem;\n  font-weight: 800;\n  margin-bottom: 0.5rem;\n  color: var(--text-primary);\n}\n\n.login-card p {\n  color: var(--text-secondary);\n  margin-bottom: 2rem;\n}\n\n.login-input-group {\n  margin-bottom: 1.25rem;\n  text-align: left;\n}\n\n.login-input-group label {\n  display: block;\n  margin-bottom: 0.5rem;\n  color: var(--text-primary);\n  font-size: 0.875rem;\n  font-weight: 600;\n}\n\n.login-input {\n  width: 100%;\n  background: var(--bg-input);\n  border: 1px solid var(--border);\n  padding: 0.875rem 1.25rem;\n  border-radius: 12px;\n  color: var(--text-primary);\n  font-size: 1rem;\n  transition: var(--transition);\n}\n\n.login-input:focus {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);\n}\n\n.login-btn {\n  width: 100%;\n  margin-top: 1rem;\n}\n\n/* Animations */\n@keyframes fadeIn {\n  from { opacity: 0; transform: translateY(10px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n.animate-fade {\n  animation: fadeIn 0.4s ease-out forwards;\n}\n\n/* Modal System - Clean Modern */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(15, 23, 42, 0.4);\n  backdrop-filter: blur(4px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n  padding: 1.5rem;\n}\n\n.modal-container {\n  background: var(--bg-card);\n  border: 1px solid var(--border);\n  border-radius: 24px;\n  width: 100%;\n  max-width: 500px;\n  padding: 2rem;\n  box-shadow: var(--shadow-md);\n  position: relative;\n  animation: modalScale 0.3s cubic-bezier(0.34, 1.56, 0.64, 1);\n}\n\n@keyframes modalScale {\n  from { opacity: 0; transform: scale(0.95); }\n  to { opacity: 1; transform: scale(1); }\n}\n\n.modal-header {\n  margin-bottom: 1.5rem;\n}\n\n.modal-header h3 {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: var(--text-primary);\n}\n\n.form-group {\n  margin-bottom: 1.25rem;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 0.5rem;\n  color: var(--text-primary);\n  font-size: 0.875rem;\n  font-weight: 600;\n}\n\n.input-field {\n  width: 100%;\n  background: var(--bg-input);\n  border: 1px solid var(--border);\n  padding: 0.75rem 1rem;\n  border-radius: 10px;\n  color: var(--text-primary);\n  font-size: 0.95rem;\n  transition: var(--transition);\n}\n\n.input-field:focus {\n  outline: none;\n  border-color: var(--primary);\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.1);\n}\n\nselect.input-field option {\n  background: var(--bg-card);\n  color: var(--text-primary);\n}\n\n.modal-actions {\n  display: flex;\n  gap: 0.75rem;\n  justify-content: flex-end;\n  margin-top: 2rem;\n}\n\n.btn-secondary {\n  background: var(--bg-card);\n  color: var(--text-secondary);\n  border: 1px solid var(--border);\n  padding: 0.75rem 1.25rem;\n  border-radius: 10px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: var(--transition);\n}\n\n.btn-secondary:hover {\n  background: var(--bg-surface);\n  color: var(--text-primary);\n}\n\n\n\n/* Client & Vehicle cards */\n        .client-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(320px, 1fr)); gap: 1.5rem; }\n        .client-card { background: var(--white); border-radius: 16px; padding: 1.5rem; box-shadow: var(--shadow); transition: all 0.2s; cursor: pointer; border: 2px solid transparent; }\n        .client-card:hover { transform: translateY(-2px); box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1); border-color: rgb(14 165 233 / 0.2); }\n        .client-header { display: flex; align-items: center; gap: 1rem; margin-bottom: 1rem; }\n        .client-avatar { width: 56px; height: 56px; border-radius: 50%; background: linear-gradient(135deg, var(--primary), var(--purple)); display: flex; align-items: center; justify-content: center; color: white; font-size: 1.25rem; font-weight: 700; }\n        .client-info h4 { font-size: 1.1rem; margin-bottom: 0.25rem; }\n        .client-info p { font-size: 0.8rem; color: var(--gray); }\n        .client-meta { display: flex; gap: 1rem; margin-top: 1rem; padding-top: 1rem; border-top: 1px solid var(--border); }\n        .client-meta-item { text-align: center; flex: 1; }\n        .client-meta-item .value { font-size: 1.25rem; font-weight: 700; color: var(--primary); }\n        .client-meta-item .label { font-size: 0.7rem; color: var(--gray); text-transform: uppercase; }\n        .client-tags { display: flex; gap: 0.5rem; margin-top: 0.75rem; flex-wrap: wrap; }\n        .tag { padding: 0.25rem 0.5rem; border-radius: 6px; font-size: 0.7rem; font-weight: 600; background: var(--light); color: var(--gray); }\n        .tag.vip { background: rgb(245 158 11 / 0.15); color: var(--warning); }\n        .tag.novo { background: rgb(16 185 129 / 0.15); color: var(--success); }\n\n        .vehicle-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(420px, 1fr)); gap: 0.6rem; }\n        .vehicle-card { background: var(--white); border-radius: 16px; overflow: hidden; box-shadow: var(--shadow); transition: all 0.2s; }\n        .vehicle-card:hover { transform: translateY(-2px); box-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1); }\n        .vehicle-image { height: 140px; background: linear-gradient(135deg, #1e293b, #334155); display: flex; align-items: center; justify-content: center; color: white; font-size: 3rem; position: relative; }\n        .vehicle-plate { position: absolute; bottom: -12px; left: 1.5rem; background: #ffeb3b; color: #1a1a1a; padding: 0.35rem 0.75rem; border-radius: 6px; font-weight: 700; font-size: 0.9rem; letter-spacing: 1px; box-shadow: 0 2px 4px rgb(0 0 0 / 0.2); }\n        .vehicle-body { padding: 1.75rem 1.5rem 1.5rem; }\n        .vehicle-title { font-size: 1.1rem; margin-bottom: 0.25rem; }\n        .vehicle-sub { font-size: 0.8rem; color: var(--gray); margin-bottom: 1rem; }\n        .vehicle-stats { display: grid; grid-template-columns: repeat(3, 1fr); gap: 0.75rem; margin-bottom: 1rem; }\n        .v-stat { text-align: center; padding: 0.75rem; background: var(--light); border-radius: 10px; }\n        .v-stat .num { font-size: 1.1rem; font-weight: 700; color: var(--dark); }\n        .v-stat .lbl { font-size: 0.65rem; color: var(--gray); text-transform: uppercase; margin-top: 0.25rem; }\n        .vehicle-alert { display: flex; align-items: center; gap: 0.5rem; padding: 0.625rem 0.875rem; border-radius: 8px; font-size: 0.8rem; font-weight: 600; margin-bottom: 1rem; }\n        .vehicle-alert.ok { background: rgb(16 185 129 / 0.1); color: var(--success); }\n        .vehicle-alert.warn { background: rgb(245 158 11 / 0.1); color: var(--warning); }\n        .vehicle-alert.danger { background: rgb(239 68 68 / 0.1); color: var(--danger); }\n        .vehicle-actions { display: flex; gap: 0.5rem; }\n        .vehicle-actions .btn { flex: 1; justify-content: center; }\n\n        /* Detail panel */\n        .detail-panel { position: fixed; top: 0; right: -480px; width: 480px; height: 100vh; background: var(--bg-card); box-shadow: -10px 0 25px rgb(0 0 0 / 0.1); z-index: 150; transition: right 0.3s ease, background 0.3s, box-shadow 0.3s; overflow-y: auto; overscroll-behavior: contain; }\n        .detail-panel.open { right: 0; }\n        .detail-header { padding: 1.5rem; border-bottom: 1px solid var(--border); display: flex; justify-content: space-between; align-items: center; }\n        .detail-body { padding: 1.5rem; }\n        .overlay-backdrop { position: fixed; inset: 0; background: rgb(0 0 0 / 0.3); z-index: 140; display: none; }\n        .overlay-backdrop.active { display: block; }\n\n        .history-list { margin-top: 1rem; }\n        .history-item { display: flex; gap: 1rem; padding: 1rem; background: var(--light); border-radius: 10px; margin-bottom: 0.75rem; }\n        .history-date { text-align: center; min-width: 50px; }\n        .history-date .day { font-size: 1.25rem; font-weight: 700; color: var(--primary); }\n        .history-date .month { font-size: 0.65rem; color: var(--gray); text-transform: uppercase; }\n        .history-content { flex: 1; }\n        .history-content h5 { font-size: 0.9rem; margin-bottom: 0.25rem; }\n        .history-content p { font-size: 0.8rem; color: var(--gray); }\n        .history-price { font-weight: 700; color: var(--success); }\n\n        /* Modal */\n        .modal-overlay { position: fixed; inset: 0; background: rgb(0 0 0 / 0.5); backdrop-filter: blur(4px); display: none; align-items: center; justify-content: center; z-index: 100; }\n        .modal-overlay.active { display: flex; }\n        .modal { background: var(--bg-card); border-radius: 20px; width: 100%; max-width: 560px; max-height: 90vh; overflow-y: auto; box-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25); animation: slideUp 0.3s ease; transition: background 0.3s; }\n        @keyframes slideUp { from { opacity: 0; transform: translateY(20px); } to { opacity: 1; transform: translateY(0); } }\n        .modal-header { padding: 1.5rem; border-bottom: 1px solid var(--border); display: flex; justify-content: space-between; align-items: center; }\n        .modal-header h3 { font-size: 1.25rem; }\n        .close-btn { background: none; border: none; font-size: 1.5rem; cursor: pointer; color: var(--gray); width: 36px; height: 36px; border-radius: 8px; display: flex; align-items: center; justify-content: center; }\n        .close-btn:hover { background: var(--bg-surface); }\n        .modal-body { padding: 1.5rem; }\n        .form-row { display: grid; grid-template-columns: 1fr 1fr; gap: 1rem; margin-bottom: 1rem; }\n        .form-group { margin-bottom: 1rem; }\n        .form-group label { display: block; font-size: 0.875rem; font-weight: 600; margin-bottom: 0.5rem; color: #334155; }\n        .form-group input, .form-group select { width: 100%; padding: 0.625rem 0.875rem; border: 2px solid var(--border); background: var(--bg-input); color: var(--text-primary); border-radius: 10px; font-size: 0.875rem; transition: all 0.2s; }\n        .form-group input:focus, .form-group select:focus { outline: none; border-color: var(--primary); }\n        .whatsapp-preview { background: #dcf8c6; padding: 1rem; border-radius: 12px; margin-top: 1rem; border-left: 4px solid #25d366; font-size: 0.875rem; line-height: 1.5; }\n        .whatsapp-preview strong { color: #075e54; }\n\n        /* Toast */\n        .toast-container { position: fixed; top: 2rem; right: 2rem; z-index: 200; display: flex; flex-direction: column; gap: 0.75rem; }\n        .toast { background: var(--bg-card); padding: 1rem 1.5rem; border-radius: 12px; box-shadow: var(--shadow-md); display: flex; align-items: center; gap: 0.75rem; animation: slideIn 0.3s ease; border-left: 4px solid var(--success); min-width: 320px; border: 1px solid var(--border); border-left-width: 4px; }\n        .toast.error { border-left-color: var(--danger); }\n        .toast.info { border-left-color: var(--primary); }\n        @keyframes slideIn { from { transform: translateX(100%); opacity: 0; } to { transform: translateX(0); opacity: 1; } }\n        .toast-icon { width: 36px; height: 36px; border-radius: 50%; background: rgb(16 185 129 / 0.1); display: flex; align-items: center; justify-content: center; color: var(--success); }\n        .toast.error .toast-icon { background: rgb(239 68 68 / 0.1); color: var(--danger); }\n        .toast.info .toast-icon { background: rgb(14 165 233 / 0.1); color: var(--primary); }\n\n/* ── AI Modal ─────────────────────────────────────────────── */\n@keyframes aiSpin { to { transform: rotate(360deg); } }\n@keyframes aiPulse { 0%,80%,100% { transform:scale(0.6);opacity:0.35; } 40% { transform:scale(1);opacity:1; } }\n@keyframes aiSlideUp { from { opacity:0; transform:translateY(24px) scale(0.97); } to { opacity:1; transform:translateY(0) scale(1); } }\n.ai-spinner { width:56px; height:56px; border-radius:50%; border:3px solid rgba(167,139,250,0.2); border-top-color:#a78bfa; animation:aiSpin 0.85s linear infinite; }\n.ai-dot { width:8px; height:8px; border-radius:50%; background:#a78bfa; animation:aiPulse 1.4s ease-in-out infinite; }\n.ai-glass { background:rgba(255,255,255,0.07); backdrop-filter:blur(32px); -webkit-backdrop-filter:blur(32px); border:1px solid rgba(255,255,255,0.15); border-radius:24px; animation:aiSlideUp 0.3s cubic-bezier(0.34,1.56,0.64,1); }\n.ai-result-line { display:flex; gap:0.5rem; margin-bottom:0.55rem; align-items:flex-start; font-size:0.875rem; line-height:1.65; color:rgba(255,255,255,0.88); }\n        \n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
